export default __webpack_public_path__ + "static/media/live5.a11e3ad7.jpeg";